import React from 'react';
import { NHAN_HANG_DOI, hangDoiChoPhep } from '../../utils/hangDoiHocVien';

/**
 * Cụm hàng đợi chọn-một.
 *
 * Trước đây ba hàng đợi nằm ở ba dạng điều khiển khác nhau — hai cái nút và một
 * checkbox ở hàng dưới — nên nhìn vào không đoán được chúng cùng loại, và không
 * biết mình đang đứng ở tập nào. Một cụm chọn-một trả lời cả hai câu đó bằng
 * chính hình dạng của nó.
 *
 * Dùng `<button aria-pressed>` chứ không phải `<Nav>` hay radio: đây là một
 * nhóm nút bật/tắt loại trừ nhau, và `aria-pressed` là thứ trình đọc màn hình
 * đọc ra đúng nghĩa đó mà không cần nhãn phụ.
 */
export default function CumHangDoi({ giaTri, onChon, allowApprove, disabled }) {
  return (
    <div role='group' aria-label='Hàng đợi học viên' className='dat-queues'>
      {hangDoiChoPhep(allowApprove).map((h) => (
        <button
          key={h}
          type='button'
          className='dat-queue'
          aria-pressed={giaTri === h}
          disabled={disabled}
          onClick={() => onChon(h)}
        >
          {NHAN_HANG_DOI[h]}
        </button>
      ))}
    </div>
  );
}
